import { Component, OnInit } from '@angular/core';
import { ActivityLogService, ActivityLog } from '../services/activity-log.service';

@Component({
  selector: 'app-activity-log',
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.scss']
})
export class ActivityLogComponent implements OnInit {
  logs: ActivityLog[] = [];
  filter: any = {};
  loading = false;
  dateFrom: string = '';
  dateTo: string = '';
  timeFrom: string = '';
  timeTo: string = '';
  actionTypes: string[] = [
    'CreateVisitor',
    'UpdateVisitor',
    'CheckinVisitor',
    'CheckoutVisitor',
    'VisitSurcharge'
  ];
  statuses: string[] = [
    'Success',
    'Error',
    'Warning',
    'Info'
  ];

  // Pagination
  currentPage: number = 1;
  itemsPerPage: number = 20;
  paginationSettings = { totalItems: 0 };

  constructor(private activityLogService: ActivityLogService) {}

  ngOnInit(): void {
    this.loadLogs();
    this.activityLogService.paginationSettings$.subscribe(pagSettings => {
      this.paginationSettings = pagSettings;
    });
  }

  loadLogs(): void {
    this.loading = true;
    this.activityLogService.getLogs({
      ...this.filter,
      pageNumber: this.currentPage,
      pageSize: this.itemsPerPage
    }).subscribe({
      next: logs => {
        this.logs = logs.map(log => ({
          ...log,
          createdAt: log.createdAt ? new Date(log.createdAt + 'Z').toLocaleString('sr-RS', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false
          }) : ''
        }));
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  changePage(pageNumber: number): void {
    this.currentPage = pageNumber;
    this.loadLogs();
  }

  applyFilter(): void {
    this.filter.dateFrom = this.dateFrom ? this.dateFrom + 'T00:00:00.000' : null;
    this.filter.dateTo = this.dateTo ? this.dateTo + 'T23:59:59.999' : null;
    this.loadLogs();
  }

  resetFilter(): void {
    this.filter = {};
    this.dateFrom = '';
    this.dateTo = '';
    this.timeFrom = '';
    this.timeTo = '';
    this.loadLogs();
  }
}
